/* eslint-disable no-lonely-if */
/* eslint-disable no-restricted-syntax */
import { initNGCarousel } from './carousel';
import { targetModalObj } from './modal';
import Utils from './utils';

let windowVHeight = window.innerHeight;
async function setvh() {
	const vh = (await window.innerHeight) * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
	windowVHeight = vh;
}
setvh();

/* window resize */
window.addEventListener('resize', function () {
	const vh = window.innerHeight * 0.01;
	if (windowVHeight !== vh) {
		windowVHeight = vh;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
});

const bodyElement = document.querySelector('body');
const keyCode = Object.freeze({
	TAB: 9,
	RETURN: 13,
	ESC: 27,
	SPACE: 32,
	PAGEUP: 33,
	PAGEDOWN: 34,
	END: 35,
	HOME: 36,
	LEFT: 37,
	UP: 38,
	RIGHT: 39,
	DOWN: 40,
});

function classToggle(toggleElement, className) {
	toggleElement.classList.toggle(className);
}

class Menu {
	constructor() {
		this.utils = new Utils();
		this.menuToggleEl = document.querySelector('.menu-toggle');
		this.navContainerNode = document.querySelector('.navigation-container');
		if (!this.navContainerNode) return;

		this.menuModalNode = this.navContainerNode.querySelector('.menu-wrapper');
		this.navCarouselNode = this.navContainerNode.querySelector('.nav-gallery-carousel');
		this.navMenubarEl = document.querySelector('#navMenubar');
		this.menuLinkEls = this.menuModalNode.querySelectorAll('#navMenubar > li > a');
		this.menuLevel1LinkEls = [...this.menuLinkEls, ...this.menuModalNode.querySelectorAll('.menu-level1-link')];
		this.backButtonEls = this.navMenubarEl?.querySelectorAll('#navMenubar > li > ul > li > .back-button');
		this.handleTrapFocus = this.trapFocus.bind(this);
		this.previousScrollY = 0;
		this.focusAfterClosed = this.menuToggleEl;
	}

	init() {
		if (!this.menuToggleEl) return;
		this.menuToggleEl.addEventListener('click', this.handleMenuToggleClick.bind(this), true);
		document.addEventListener('keydown', this.handleESCPress.bind(this), true);
	}

	open(target) {
		if (targetModalObj && bodyElement.classList.contains('contactopen')) {
			targetModalObj.getOpenDialog.close();
		}

		const validRoles = ['dialog', 'alertdialog'];
		const isModal = (this.navContainerNode.getAttribute('role') || '')
			.trim()
			.split(/\s+/g)
			.some(function (token) {
				return validRoles.some(function (role) {
					return token === role;
				});
			});
		if (!isModal) {
			throw new Error('Modal() requires a DOM element with ARIA role of dialog or alertdialog.');
		}

		this.navContainerNode.classList.remove('h-0', 'invisible');
		this.menuModalNode.classList.add('open');
		this.navContainerNode.setAttribute('aria-hidden', false);
		this.navCarouselNode.tabIndex = 0;
		this.focusFirst = this.navContainerNode.querySelector('a');

		const preDiv = document.createElement('div');
		this.preNode = this.navContainerNode.parentNode.insertBefore(preDiv, this.navContainerNode);
		this.preNode.tabIndex = 0;
		const postDiv = document.createElement('div');
		this.postNode = this.navContainerNode.parentNode.insertBefore(postDiv, this.navContainerNode.nextSibling);
		this.postNode.tabIndex = 0;

		if (this.openModal) {
			this.openModal.removeListeners();
		}

		this.addListeners();
		this.openModal = this;

		if (this.focusFirst) {
			this.focusFirst.focus();
		} else {
			this.utils.focusFirstDescendant(this.navContainerNode);
		}

		this.lastFocus = document.activeElement;

		initNGCarousel();
		this.previousScrollY = window.scrollY;
		// eslint-disable-next-line no-param-reassign
		target.children[0].innerHTML = 'Close';
	}

	close() {
		this.openModal = null;
		this.removeListeners();
		this.navContainerNode.parentNode.removeChild(this.preNode);
		this.navContainerNode.parentNode.removeChild(this.postNode);
		bodyElement.classList.remove('menuopen');
		window.scrollTo(0, this.previousScrollY);
		this.menuModalNode.classList.remove('open');
		this.menuToggleEl.children[0].innerHTML = 'Menu';
		this.navContainerNode.classList.add('h-0', 'invisible');
		this.navContainerNode.setAttribute('aria-hidden', true);
		this.navCarouselNode.tabIndex = -1;
		this.focusAfterClosed.focus();
	}

	addListeners() {
		document.addEventListener('focus', this.handleTrapFocus, true);

		for (const el of this.backButtonEls) {
			el.addEventListener('click', this.handleBackButtonClick.bind(this), true);
		}

		for (const el of this.menuLinkEls) {
			if (el && el.tagName === 'A') {
				el.addEventListener('click', this.handleMenuLinkClick.bind(this), true);
			}
		}
	}

	removeListeners() {
		document.removeEventListener('focus', this.handleTrapFocus, true);
	}

	trapFocus(event) {
		if (this.utils.getIgnoreUtilFocusChanges) {
			return;
		}
		const currentModal = this.openModal;

		if (currentModal.navContainerNode.contains(event.target)) {
			currentModal.lastFocus = event.target;
		} else {
			this.utils.focusFirstDescendant(currentModal.navContainerNode);
			if (currentModal.lastFocus === document.activeElement) {
				this.utils.focusLastDescendant(currentModal.navContainerNode);
			}
			currentModal.lastFocus = document.activeElement;
		}
	}

	addClickable() {
		for (const el of this.menuLevel1LinkEls) {
			el.removeAttribute('tabIndex');
		}
	}

	removeClickable() {
		for (const el of this.menuLevel1LinkEls) {
			el.tabIndex = -1;
		}
	}

	handleMenuToggleClick(event) {
		event.preventDefault();
		event.stopPropagation();

		const target = event.currentTarget;
		classToggle(bodyElement, 'menuopen');

		if (bodyElement.classList.contains('menuopen')) {
			this.open(target);
			// bodyElement.style.position = 'fixed';
		} else {
			if (this.openModal) {
				this.openModal.close();
			}
			// bodyElement.style.position = 'initial';
		}
	}

	handleESCPress(event) {
		switch (event.keyCode) {
			case keyCode.ESC:
				event.stopPropagation();
				event.preventDefault();

				if (this.openModal) {
					this.openModal.close();
				}
				break;

			default:
				break;
		}
	}

	handleMenuLinkClick(event) {
		const nextEl = event.currentTarget.nextElementSibling;

		if (nextEl && nextEl.tagName === 'UL') {
			event.preventDefault();
			event.stopPropagation();
			nextEl.classList.add('open');
			this.removeClickable();
			this.menuModalNode.classList.add('overflow-y-hidden');
		} else {
			nextEl.classList.remove('open');
			this.addClickable();
			this.menuModalNode.classList.remove('overflow-y-hidden');
		}
	}

	handleBackButtonClick(event) {
		event.preventDefault();
		event.stopPropagation();
		const subMenuEl = event.currentTarget.closest('ul');

		if (subMenuEl && subMenuEl.tagName === 'UL') {
			subMenuEl.classList.remove('open');
			this.addClickable();
			this.menuModalNode.classList.remove('overflow-y-hidden');
		}
	}
}

const menubar = new Menu();
menubar.init();

export { Menu, menubar };
